import { render, staticRenderFns } from "./ItemDetailSublet.vue?vue&type=template&id=3f74e849&scoped=true"
import script from "./ItemDetailSublet.vue?vue&type=script&lang=js"
export * from "./ItemDetailSublet.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailSublet.vue?vue&type=style&index=0&id=3f74e849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74e849",
  null
  
)

export default component.exports